import { createSlice } from '@reduxjs/toolkit';

export const meta = createSlice({
  name: 'meta',
  initialState: {
    data: {},
  },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setData } = meta.actions;

export const selectData = (state) => state.meta.data;

export default meta.reducer;
